export default __webpack_public_path__ + "static/organizationPlaceholder-0ba517bc6ebe1ccc8175ef5c2dcee9a3.webp";